import { VariantStatus } from '../../manage/utils/variantUtils'

import IconsBase from './IconsBase'

type Props = {
  statusFilter: VariantStatus
  hasLoadingVariants?: boolean
  showInputResultsButton?: boolean
  onInputResultsClick?: () => void
}

const ExpandedIcons = (props: Props) => (
  <IconsBase {...props} tooltipPlacement="top" />
)

export default ExpandedIcons
